import {Formik, Field, Form, ErrorMessage, useFormik} from 'formik';
import {useState, useEffect} from 'react';
import * as Yup from 'yup';
import AutoCompletePostalCode from '../../common-scripts/CustomFields/AutoCompletePostalCode';
import ModalComponent from '../../common-scripts/Helpers/ModalComponent';
import MessageStatus from './MessageStatus';
import Spinner from "../../common-scripts/Helpers/Spinner";
import axios from 'axios'

/**
 * Main Component
 *
 * @param homeUrl
 * @param referencesUrl
 * @returns {JSX.Element}
 * @constructor
 */
function App({homeUrl, referencesUrl, assistanceTexts}) {
	const [showmadal, SetShowModal] = useState(false);
	const [showloader, setShowloader] = useState(false);
	const [isValidForm, setIsValidForm] = useState(false);
	const referencesUrls = JSON.parse(referencesUrl);
	const textAssistance = JSON.parse(assistanceTexts);

	const initialValues = {
		firstName: '',
		lastName: '',
		address: '',
		postalCode: '',
		city: '',
		numContrat: ''
	}


	const onSubmit = () => {
		saveSubscriberForm(formik.values);

	}


	const saveSubscriberForm = (data) => {

		setShowloader(true);

		axios.post(homeUrl + "/wp-json/gdv/v1/save", {
			step: 0,
			email: null,
			status: "courrier",
			data: [data]
		}, {
			headers: {
				"Content-Type": 'application/json',
				"Accept": "application/json"
			}
		}).then((response) => {
			SetShowModal(true);


		}).catch((error) => {
			console.log(error)
			console.log(error.response)
			console.log(error.config);
			setShowloader(false);

		});
	}


	const onBackHome = () => {
		window.location.href = homeUrl;
	}

	const onPostalCodeChange = (referentiels, cityName, postalCodeName, formik) => {

		formik.setFieldValue(postalCodeName, referentiels.postal_code);
		formik.setFieldValue(cityName, referentiels.city_name);
		formik.setTouched({...formik.touched, [postalCodeName]: true, [cityName]: true});

	}

	const nameRegExp =  /^[a-zA-ZÀ-ÿ]+(?:[ \-][a-zA-ZÀ-ÿ]+)*$/;

	const validationSchema = Yup.object({
		firstName: Yup.string().required('Merci de renseigner le nom').matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		lastName: Yup.string().required('Merci de renseigner le prénom').matches(
			nameRegExp,
			'Le nom entré est invalide'
		),
		address: Yup.string().required('Merci de renseigner l\'adresse'),
		postalCode: Yup.string().required('Merci de renseigner le code postal'),
		city: Yup.string().required('Merci de renseigner la ville'),
		numContrat: Yup.string().notRequired(),
	});

	const formik = useFormik({
		validationSchema: validationSchema,
		initialValues: initialValues
	})

	useEffect(() => {
		formik.validateForm().then((res) => {
			setIsValidForm(Object.keys(res).length == 0);
		});


	}, [formik.values])

	return <React.Fragment>

		<div className="row center ">

			<div className="col-xs-12 col-lg-4 gutter">

				<div className="assistance-banner">
					<h2>{textAssistance.title}</h2>
					<a href={textAssistance.ctaUrl} title={textAssistance.ctaLabel}
					   className="bouton bouton-full bouton-business bouton-picto">
						<span className="arrow"><i className="fa fa-phone"></i></span><span
						className="text">{textAssistance.ctaLabel}</span>
					</a>
					<p>
						{textAssistance.numPhoneText} <br/>
						<span>{textAssistance.subText}</span>
						<br/>
						<span className="business-info">{textAssistance.subText2}</span> <br/>

					</p>

				</div>
			</div>
			<div className="col-xs-12 col-lg-8">

				<div className="card-banner info">
					<p> Vous avez choisi de recevoir votre recueil des volontés par courrier. </p>
				</div>


				<form>


					<div className="form-card">
						<div className="card-header">
							Je soussigné(e) :
						</div>
						<div className="card-body">

							<div className="form-group block ">
								<label className="control-label" htmlFor="firstName">Prénom <span>*</span> :</label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.firstName}
										   name="firstName" type="text" placeholder="Saisissez votre prénom"
										   title="Saisissez votre prénom"/>
									{(formik.errors.firstName && formik.touched.firstName) && (
										<span className="msg-error">{formik.errors.firstName}</span>
									)}
								</div>
							</div>
							<div className="form-group block ">
								<label className="control-label" htmlFor="lastName">Nom <span>*</span> : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.lastName} name="lastName"
										   type="text" placeholder="Saisissez votre nom" title="Saisissez votre nom"/>
									{(formik.errors.lastName && formik.touched.lastName) && (
										<span className="msg-error">{formik.errors.lastName}</span>
									)}
								</div>
							</div>
							<div className="form-group block ">
								<label className="control-label" htmlFor="address">Adresse <span>*</span> : </label>
								<div className="container-input">
									<input className="form-control" onBlur={formik.handleBlur}
										   onChange={formik.handleChange} value={formik.values.address} name="address"
										   type="text" placeholder="Saisissez votre adresse"
										   title="Saisissez votre adresse"/>
									{(formik.errors.address && formik.touched.address) && (
										<span className="msg-error">{formik.errors.address}</span>
									)}
								</div>
							</div>

							<div className="form-group block ">
								<label className="control-label" htmlFor="postalCode">Code postal <span>*</span> :
								</label>
								<div className="container-input">
									<AutoCompletePostalCode onPostalCodeChange={onPostalCodeChange} formik={formik}
															cityName="city" postalCodeName="postalCode"
															refUrl={referencesUrls.referentiel}/>
									{formik.errors.postalCode && formik.touched.postalCode ?
										<span className='msg-error'>{formik.errors.postalCode}</span> : null}
								</div>
							</div>
							<input hidden={true} onChange={formik.handleChange} onBlur={formik.handleBlur}
								   value={formik.values.postalCode} name="postalCode" id="postalCode"/>

							<div className="form-group block ">
								<label className="control-label" htmlFor="city">Ville <span>*</span>: </label>
								<div className="container-input">
									<input className="form-control" onChange={formik.handleChange}
										   value={formik.values.city} name="city" type="text"
										   placeholder="Saisissez votre ville " title="Saisissez votre ville "/>
									{formik.errors.city && formik.touched.city ?
										<span className='msg-error'>{formik.errors.city}</span> : null}
								</div>
							</div>

							<div className="form-group block ">
								<label className="control-label" htmlFor="numContrat">Numéro de contrat : </label>
								<div className="container-input">
									<input className="form-control" onChange={formik.handleChange}
										   value={formik.values.numContrat} name="numContrat" type="text"
										   placeholder="Saisissez votre numéro de contrat"
										   title="Saisissez votre numéro de contrat"/>
								</div>
							</div>

						</div>
					</div>

					<div className="bottom">

						<div className="actions">
							<div>
								<button onClick={() => onSubmit()} type='button' title="Envoyer"
										className={`bouton bouton-full bouton-business bouton-picto-r goto_backto ${isValidForm ? "ready" : "wait"}`}>
									<span>Envoyer</span> <i className="fun-picto fun-picto-arrow-right"></i></button>
							</div>
						</div>
					</div>


				</form>


			</div>

		</div>

		{showloader && <Spinner/>}
		{showmadal && <ModalComponent showModal={true} content={<MessageStatus onBackHome={onBackHome}/>}/>}


	</React.Fragment>;
}

export default App;


